import { SelectColorInput } from "./SelectColorInput";

export default SelectColorInput;
